module.exports = __webpack_public_path__ + "img/banner2-500-ja.c37be7bf.png";